const doc = [({"zh_cn":({"adminConstantHotelStayType":({"allTypes":"住宿和一日游", "oneDayTrip":"仅限一日游", "stay":"仅住宿"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;